// extracted by mini-css-extract-plugin
export default {"tab":"tab-KyFb4","activeTab":"activeTab-W1WNE","tabsRow":"tabsRow-aOLaW","tabsLine":"tabsLine-qkpBe"};